import { render, staticRenderFns } from "./PeakScales.vue?vue&type=template&id=10cbe6dc&scoped=true"
import script from "./PeakScales.vue?vue&type=script&lang=js"
export * from "./PeakScales.vue?vue&type=script&lang=js"
import style0 from "./PeakScales.vue?vue&type=style&index=0&id=10cbe6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbe6dc",
  null
  
)

export default component.exports